<template>
  <section id="tickets" class="spacer">
    <div class="title big" v-html="tickets.title"></div>
    <div class="big pt ">
      <a target="_blank" :href="tickets.tickets">{{ $t("buy") }}</a>
    </div>
  </section>
</template>

<script>
import API from "@/api/service";
export default {
  data() {
    return {
      tickets: []
    };
  },
  created() {
    API.tickets(this.$i18n.locale).then(page => {
      this.tickets = page.data.result;
    });
  }
};
</script>

<style></style>
